// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_pages_module_ts":"e895625669270e52","src_app_public_public_module_ts":"e370b9fdef1a7de2"}[chunkId] + ".js";
};